import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Feedback } from '../../models/Feedback';
import { Rating } from '../../models/Rating';
import { Customer } from '../../models/Customer';
import * as FeedbackActions from '../../state/feedback/feedback.actions';
import * as CustomerActions from '../../state/customer/customer.actions';
import { selectCustomer } from '../../state/customer/customer.selector';
import { DualAuthService } from '../../services/DualAuthService';
import { filter, take } from 'rxjs';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { PageHeaderComponent } from '../page-header/page-header.component';
@Component({
  selector: 'app-feedback',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    MatCardModule,
    PageHeaderComponent,
  ],
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.css'],
})
export class FeedbackComponent implements OnInit {
  feedbackText: string = '';
  rating: Rating = new Rating({ id: 1, value: 0 });
  customer: Customer | null = null;

  constructor(private store: Store, private auth: DualAuthService) {
    this.store.select(selectCustomer).subscribe((customer) => {
      this.customer = customer;
    });
  }

  ngOnInit(): void {
    // Only fetch customer context for CIAM customers
    const userName = localStorage.getItem('userName');
    this.auth.currentUser$
      .pipe(filter(u => !!u), take(1))
      .subscribe(() => {
        if (!this.auth.isCustomer()) return;
        if (userName && userName.trim().length > 0) {
          this.store.dispatch(CustomerActions.getCustomerByUserName({ userName }));
        } else {
          this.store.dispatch(CustomerActions.getCurrentCustomer());
        }
      });
  }

  setRating(value: number) {
    this.rating = new Rating({ id: 1, value: value });
  }

  onSubmit() {
    if (!this.customer) return;
    const feedback = new Feedback({
      text: this.feedbackText,
      rating: this.rating,
      customer: this.customer,
    });
    this.store.dispatch(
      FeedbackActions.submitFeedback({
        feedbackText: this.feedbackText,
        rating: this.rating.value,
        userName: localStorage.getItem('userName') || '',
      })
    );
    this.feedbackText = '';
    this.rating = new Rating({ id: 1, value: 0 });
  }
}
